import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SseClient} from 'ngx-sse-client';
import {DeviceIdService} from '../../../utils/services/device-id.service';
import {environment} from '../../../../environments/environment';
import {StudySnapshotDTO} from '../dto/study-snapshot';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SnapshotService {
  private readonly sseClient: SseClient = inject(SseClient);
  private readonly deviceIdService: DeviceIdService = inject(DeviceIdService);
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/snapshot';


  generateStudySnapshot(projectId: number, paperId: number): Observable<StudySnapshotDTO> {
    const url = `${this.apiUrl}/${projectId}/paper/${paperId}`;
    return this.http.get<StudySnapshotDTO>(url);
  }
}
